/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown> }} Subtitle_Extract_Track_708Inputs */



/**
* | output |
* | --- |
* | "CEA-708 Service {service}" |
*
* @param {Subtitle_Extract_Track_708Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_track_708 = /** @type {((inputs: Subtitle_Extract_Track_708Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Track_708Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Service CEA-708 ${i?.service}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`CEA-708 Service ${i?.service}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Servizio CEA-708 ${i?.service}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сервис CEA-708 ${i?.service}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Servicio CEA-708 ${i?.service}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`CEA-708 服务 ${i?.service}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`CEA-708サービス ${i?.service}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`CEA-708 सेवा ${i?.service}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Serviço CEA-708 ${i?.service}`)
	return /** @type {LocalizedString} */ (`CEA-708 Service ${i?.service}`)
});